module.exports = __webpack_public_path__ + "fonts/ProximaNovaT-Thin.woff";